









































import { Vue, Component, Prop } from "vue-property-decorator";
import { ScoutingPlace } from "../../models";
import { currentScoutingStore } from "@/store/typed";

@Component
export default class ScoutingPlaceItem extends Vue {
  @Prop({ required: true }) readonly scoutingPlace!: ScoutingPlace;
  @Prop({ default: false }) readonly deletable!: boolean;
  @Prop({ default: true }) readonly navigate!: boolean;

  private item = Object.assign(new ScoutingPlace(), this.scoutingPlace);

  hovered = false;

  get isItemSelected() {
    return (
      currentScoutingStore.analysisCurrentScoutingPlace?.id ===
      this.scoutingPlace.id
    );
  }

  onDelete() {
    currentScoutingStore.destroyScoutingPlace(this.scoutingPlace.id);
  }
  get differentIsocron() {
    if (this.$route.name === "company_analysis") {
      return false;
    }
    return this.scouting
      ? !this.scoutingPlace.hasScoutingIsocron(this.scouting)
      : false;
  }

  get scouting() {
    return currentScoutingStore.scouting;
  }

  get isLoading() {
    return this.scoutingPlace?.isocron?.isLoading;
  }

  onSelectClicked() {
    if (this.navigate) {
      currentScoutingStore.updateScoutingPlace(this.item);
      currentScoutingStore.centerOnMarker(this.item);
      this.$router.push({
        name: "scouting-poi-show",
        params: { id: this.item.id },
      });
    } else {
      this.$emit("clicked", this.scoutingPlace);
    }
  }
}
